export default "__VITE_ASSET__BgQyqZfL__"